import React from "react"
import "./index.scss"
import InnerSection from "./InnerSection"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function StaticGrid({ component }) {
  // = = = = = = = = = = = = =
  // Data
  const { intro, headline, innerSections, backgroundImage } = component

  const img = getImage(backgroundImage)

  return (
    <section data-datocms-noindex className="static-content">
      <GatsbyImage image={img} />

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="intro-wrapper">
              <h2 className="static-content__headline oblique">{headline}</h2>
              <p
                className="static-content__text"
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            </div>
          </div>
        </div>

        {innerSections.map(sectionData => (
          <InnerSection sectionData={sectionData} />
        ))}
      </div>
    </section>
  )
}
